'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GlutenFreeSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GlutenFreeSvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgGF', width: size, height: size, viewBox: '0 0 27 27', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-gluten-free' },
        _react2.default.createElement(
            'title',
            { id: 'outImgGF' },
            i18n.get('openrest_menubuilderv3_dishlabels_glutenfree') || 'Gluten Free'
        ),
        _react2.default.createElement('path', {
            d: 'M13.6499 25.999c-3.67 0-6.962-1.618-9.226-4.168l4.151-3.289c.197.376.447.738.771 1.056 1.155 1.13 2.838 1.339 3.744 1.365v1.723c0 .359.291.65.65.65.359 0 .65-.291.65-.65v-1.722c.895-.021 2.612-.22 3.785-1.366 1.608-1.576 1.455-4.238 1.447-4.35l-.036-.558-.557-.047c-.021-.002-.146-.012-.339-.014.82-1.217.933-2.728.939-3.392l4.73-3.712c1.039 1.807 1.641 3.895 1.641 6.125 0 6.809-5.54 12.349-12.35 12.349m1.909-9.071c.79-.774 2.02-.956 2.753-.992-.053.733-.262 1.964-1.047 2.732-.79.774-2.022.956-2.753.991.051-.73.258-1.958 1.047-2.731m-3.598-.001c.79.773.997 2 1.047 2.73-.733-.037-1.968-.22-2.753-.989-.79-.773-.997-1.998-1.047-2.73.733.038 1.969.221 2.753.989m1.047-1.617c-.733-.038-1.968-.221-2.753-.99-.79-.772-.997-1.998-1.047-2.729.733.037 1.969.22 2.753.989.79.773.997 1.999 1.047 2.73m5.306-3.721c-.051.731-.258 1.958-1.049 2.731-.79.775-2.022.956-2.753.991.051-.73.258-1.958 1.047-2.731.791-.774 2.022-.956 2.755-.991m-4.532-4.202c.483.55 1.206 1.563 1.197 2.67-.009 1.107-.748 2.107-1.24 2.65-.483-.551-1.206-1.563-1.197-2.669.009-1.107.749-2.108 1.24-2.651m-.132-6.087c4.113 0 7.753 2.029 9.999 5.13l-4.059 3.185V8.607c0-.359-.291-.65-.65-.65-.36 0-.651.291-.651.65v1.68c-.542.024-1.312.119-2.081.405.035-.204.069-.409.071-.625.016-1.902-1.396-3.446-1.889-3.929V4.337c0-.359-.291-.65-.65-.65-.359 0-.65.291-.65.65V6.23c-.569.564-1.833 2.011-1.848 3.797-.002.228.03.446.065.662-.798-.296-1.594-.385-2.137-.403V8.607c0-.359-.291-.65-.65-.65-.359 0-.65.291-.65.65v2.126c0 .053.018.101.03.15v.017c-.007.099-.127 2.162.933 3.73-.194.002-.318.012-.341.013l-.556.047-.036.557c-.005.064-.056.962.2 2.013l-4.489 3.555c-1.449-2.023-2.311-4.493-2.311-7.165 0-6.81 5.54-12.35 12.35-12.35m0-1.3c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65s13.651-6.124 13.651-13.65c0-7.527-6.124-13.65-13.651-13.65',
            fill: primaryColor })
    );
}

GlutenFreeSvg.displayName = 'GlutenFreeSvg';
GlutenFreeSvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
GlutenFreeSvg.defaultProps = {
    size: 28,
    primaryColor: '#fbb446'
};